import React, { useEffect, useState, useMemo } from 'react';
import { fetcher } from '../../../../../helpers/fetcher';
import { fetcherAsync } from '../../../../../helpers/fetcherAsync';
import { configApiLinks } from '../../../../../configApiLinks';
import { config } from '../../../../../config';

export const useZReportsVchasno = () => {
  const [modalShow, setModalShow] = useState(false);
  const [zReportsList, setZReportsList] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [filterDateStart, setFilterDateStart] = useState((new Date()).setDate(new Date().getDate() - 2));
  const [filterDateEnd, setFilterDateEnd] = useState(new Date());
  const [frId, setFrId] = useState(0);

  useEffect(() => {
    if (modalShow === true) {
      getZReports(frId, filterDateStart, filterDateEnd);
    }
  }, [modalShow]);

  const getZReports = (inFrId, inDateStart, inDateEnd) => {
    if (inDateStart !== filterDateStart) {
      setFilterDateStart(inDateStart);
    }
    if (inDateEnd !== filterDateEnd) {
      setFilterDateEnd(inDateEnd);
    }
    if (inFrId !== frId) {
      setFrId(inFrId);
    }
    setShowLoader(true);
    fetcher(configApiLinks.getZReports, 'POST', {
      dateStart: Date.parse(inDateStart),
      dateEnd: Date.parse(inDateEnd),
      frId: inFrId,
    }).then((data) => {
      setShowLoader(false);
      setZReportsList(data);
    });
  };

  const printZReport = async (shiftId, fisn, localn) => {
    const printData = await fetcherAsync(configApiLinks.getShiftPrintData, 'POST', { frId, shiftId, fisn, localn }, true);
    console.log({ printData });
    const fileUrl = `${config.printUrl}shifts/${shiftId}.png`;
    printImage(fileUrl);
  };

  const printImage = (url) => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
        <html>
        <head>
            <title>PRINT</title>
            <style>
                body { text-align: center; margin: 0; padding: 20px; }
                img { max-width: 100%; height: auto; cursor: pointer; }
            </style>
        </head>
        <body>
            <img src="${url}" onclick="window.close()" ontouchstart="window.close()" onload="setTimeout(() => window.print(), 500);">
            <script>
                let hasPrinted = false;

                function handleVisibilityChange() {
                    if (document.visibilityState === 'hidden') {
                        hasPrinted = true;
                    } else if (hasPrinted) {
                        setTimeout(() => window.close(), 1000);
                    }
                }

                document.addEventListener('visibilitychange', handleVisibilityChange);
            </script>
        </body>
        </html>
    `);
    printWindow.document.close();
  }

  // here we put
  const delay = (callback, ms) => {
    let timer = 0;
    // return function because keyup require function
    return function () {
      let context = this;
      let args = arguments;
      // if we put something again clear timer (do not wait for result function below) amd start timer again
      clearTimeout(timer);
      timer = setTimeout(function () {
        // runs function on key up ajax send format url etc...
        callback.apply(context, args);
      }, ms);
    };
  };
  return {
    delay,
    zReportsList,
    getZReports,
    printZReport,
    modalShow,
    showLoader,
    filterDateStart,
    filterDateEnd,
    setModalShow,
    frId
  };
};
